<script>
  import axios from "axios"
  import ApplicationState from "../../../../Stores/applicationStates"
  import BadgeSection from "./Components/badgeSection.svelte"
  import NavBar from "./Components/navBar.svelte"
  import Modals from "./Modals/index.svelte"
  import BadgeState from "../Stores/badgeState"
  import Footer from "./Components/footer.svelte"
  import TitleCard from "./Components/titleCard.svelte"
  import { push, querystring } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import { onDestroy, onMount } from "svelte"
  import notify from "../../../../Script/notify"
  import LoadingScreen from "../../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import defaultFonts from "../../File/stores/fileTemplateDefaultFonts"
  import { loadCSS } from "../../../../Script/loadLibrary"
  import ResumeStartmodal from "../Edit/Modals/resumeStartModal/index.svelte"
  import CropConfirmationModal from "./Modals/cropConfirmationModal.svelte"
  import { drawChecked, loadImage } from "../../File/Edit/Script/loadImg"
  import { getRequest } from "../../../../Script/apiMethods"

  let query
  let chooseBoxModal = false
  let baseCanvas
  let loader = true
  let loadingText = ""
  let cropConfirm = false

  let cropCanvas = false

  let showCropLoader = false
  let initialData = {}

  let closeNotification = {
    close() {},
  }

  onMount(async () => {
    try {
      query = queryStringToJSON($querystring)
      checkResolution()
      loader = true
      loadingText = "Fetching badge data"
      if (query.id == "000000000000000000000000") {
        chooseBoxModal = true
        goInitialState()
        return
      } else {
        if ($BadgeState.baseInfo.id && $BadgeState.baseInfo.id == query.id) {
          if (window.innerWidth > 1023) $BadgeState.resumeModal = true
        } else {
          if ($BadgeState.resumeModal) $BadgeState.resumeModal = false
          if ($BadgeState.goBack) $BadgeState.goBack = false
          await differentIdCondition()
        }
      }

      initialData = JSON.parse(JSON.stringify($BadgeState))
    } catch (error) {
      console.error(error)
      const info = "PAGE: Badge Template Editor\nEVENT: onMount"
      notify.danger(error, info)
      push(`/templates/badge`)
    } finally {
      loader = false
    }
  })

  const goInitialState = () => {
    $BadgeState = {
      name: "",
      baseInfo: {},
      operations: [],
      fonts: [],
      apiFonts: [],
      download: false,
      cursorPosition: {
        x: 0,
        y: 0,
      },
      canvasColor: "transparent",
      activeFontStyles: [],
      activeTextAlign: "center",
      activeTextColor: "#f2072e",
      goBack: false,
      resumeModal: false,
      footer: "GENERAL",
    }
  }

  const loadFontLibrary = () => {
    return new Promise(async (resolve, reject) => {
      try {
        for (let i = 0; i < $BadgeState.fonts.length; i++) {
          let newFontname = await fetchSingleFont($BadgeState.fonts[i])

          $defaultFonts.selectedFonts = [...$defaultFonts.selectedFonts, newFontname]

          $defaultFonts.selectedFonts.sort()
          $defaultFonts.selectedFonts = [...new Set($defaultFonts.selectedFonts)]

          $BadgeState.apiFonts = [...$BadgeState.apiFonts, newFontname]
          $BadgeState.apiFonts = [...new Set($BadgeState.apiFonts)]
        }
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  const fetchSingleFont = (fontID) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        const { data } = await axios.get(`/api/swagger/v2/fonts/${fontID}`, {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })

        //error checking while api call
        if (data.error && !data.success) {
          if (data.errorCode == "P2BCODE::FONT_DOES_NOT_EXIST") resolve("Arial")
          else throw data.errorCode
        }
        await loadCSS(data.font.name, data.font.uri)

        resolve(data.font.name)
      } catch (error) {
        reject(error)
      }
    })
  }

  const footerNotification = () => {
    $BadgeState.operations.map((operation) => {
      if (operation.active) {
        if (operation.type == "text") {
          $BadgeState.footer = "TEXT"
        } else if (operation.type == "shape") {
          $BadgeState.footer = "SHAPE"
        } else if (operation.type == "image") {
          $BadgeState.footer = "IMAGE"
        } else {
          $BadgeState.footer = "RIBBON"
        }
      } else {
        $BadgeState.footer = "GENERAL"
      }
    })
  }

  let timer = setInterval(() => {
    $BadgeState.footer = "Auto Saving.."
    localStorage.setItem("BadgeApp", JSON.stringify($BadgeState))
    setTimeout(() => {
      footerNotification()
      // $BadgeState.footer = "GENERAL"
    }, 1000)
  }, 30000)

  onDestroy(() => {
    clearTimeout(timer)
  })

  const differentIdCondition = async () => {
    try {
      loader = true
      closeNotification.close()
      // loadFontList()

      const { template } = await getRequest(`/api/swagger/v2/templates/badges/${query.id}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      const badgeData = template

      $defaultFonts.selectedFonts = ["Arial", "Arial Black", "Courier New", "Comic Sans MS", "Times New Roman", "Impact", "Tahoma", "Verdana"]

      $BadgeState.name = badgeData.name
      $BadgeState.operations = JSON.parse(badgeData.operations)
      $BadgeState.fonts = JSON.parse(badgeData.fonts)
      $BadgeState.canvasColor = badgeData.bgColour
      $BadgeState.baseInfo = {}
      $BadgeState.baseInfo.height = badgeData.height
      $BadgeState.baseInfo.width = badgeData.width
      $BadgeState.baseInfo.id = badgeData.id
      $BadgeState.cursorPosition = {
        x: 0,
        y: 0,
      }

      $BadgeState.state = ""
      $BadgeState.download = false
      $BadgeState.footer = "GENERAL"

      //loading Fonts
      if ($BadgeState.operations.length == 0) {
        let textJsonData = {
          id: Date.now(),
          active: true,
          type: "text",
          fontSize: 30,
          fontFamily: "Arial",
          fontWeight: ["Bold"],
          value: "Click to verify",
          // offset: 45,
          letterSpacing: 30,
          radius: 0,
          isRounded: false,
          rotation: 0,
          move: false,
          textColor: $BadgeState.activeTextColor || "#f2072e",
          textAlign: $BadgeState.activeTextAlign || "center",
          x: Math.floor($BadgeState.baseInfo.width / 2),
          y: Math.floor($BadgeState.baseInfo.height / 2),
        }

        $BadgeState.operations = [textJsonData, ...$BadgeState.operations]
      }

      await loadFontLibrary()
      await redrawImageLayers()
      // setTimeout(() => {
      //   $BadgeState.fonts = fontList
      // }, 250)
      if ($BadgeState.resumeModal) $BadgeState.resumeModal = false
      push(`/templates/badge/edit?id=${$BadgeState.baseInfo.id}`)
    } catch (error) {
      const info = "PAGE: Badge Template Editor\nEVENT: While continuing with badge data from API"
      closeNotification = notify.danger(error, info)
      if (error == "P2BCODE::BADGE_TEMPLATE_DOES_NOT_EXIST") push("/templates/badge")
    } finally {
      loader = false
    }
  }

  const loadFontList = () => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        const { data } = await axios.get("/api/swagger/v2/fonts", {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })
        // Error checking while API call
        if (data.error && !data.success) {
          throw data.errorCode
        }

        let fontList = [...data.fonts]

        $BadgeState.fonts = []

        for (let i = 0; i < $BadgeState.operations.length; i++) {
          if ($BadgeState.operations[i].type == "text") {
            for (let j = 0; j < fontList.length; j++) {
              if (fontList[j].name == $BadgeState.operations[i].fontFamily) {
                $BadgeState.fonts = [...$BadgeState.fonts, fontList[j].id]
              }
            }
          }
        }
        $BadgeState.fonts = [...new Set($BadgeState.fonts)]
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  const redrawImageLayers = () => {
    return new Promise(async (resolve, reject) => {
      try {
        if ($BadgeState.operations.length) {
          for (let i = 0; i < $BadgeState.operations.length; i++) {
            if ($BadgeState.operations[i].type == "image") {
              if ($BadgeState.operations[i].src && $BadgeState.operations[i].src.startsWith("/ipfs")) {
                $BadgeState.operations[i].image = await loadImage($BadgeState.operations[i].src)
              } else {
                $BadgeState.operations[i].src = drawChecked($BadgeState.operations[i].width, $BadgeState.operations[i].height)
                $BadgeState.operations[i].image = await loadImage($BadgeState.operations[i].src)
                $BadgeState.operations[i].uploadImage = true
              }
            }
          }
        }
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  const resumeProcess = async () => {
    try {
      loader = true
      await loadFontList()
      await loadFontLibrary()
      await redrawImageLayers()
      $BadgeState.resumeModal = false
    } catch (error) {
      console.error(error)
      const info = "PAGE: Badge Template Editor\nEVENT: While resuming with local badgeData"
      notify.danger(error, info)
    } finally {
      loader = false
    }
  }

  let countdown = 10
  let countDownTimer = setInterval(() => {
    if (countdown > 0) {
      countdown = Math.round((countdown - 1) * 10) / 10
    } else {
      clearInterval(countDownTimer)
    }
  }, 1000)

  let showEditor = false
  const checkResolution = () => {
    if (window.innerWidth > 1023) {
      showEditor = true
    } else {
      showEditor = false
      setTimeout(() => {
        push("/templates/badge")
      }, 10000)
    }
  }
</script>

<svelte:head>
  <title>Badge Design Template Editor</title>
</svelte:head>

<div class="flex h-screen w-screen overflow-hidden bg-gray-c00 text-center">
  <!-- {#if $BadgeState && Object.keys($BadgeState.baseInfo).length} -->

  {#if showEditor && !loader}
    <div class="relative">
      <div class="fixed top-0 left-0 z-20 flex h-screen w-screen select-none bg-gray-c00">
        {#if chooseBoxModal}
          <Modals
            bind:loader
            bind:chooseBoxModal
            on:click={() => {
              if ($BadgeState && !Object.keys($BadgeState.baseInfo).length) push(`/templates/badge/`)
              chooseBoxModal = false
            }}
          />
        {/if}
        <div class="z-10 flex h-full w-[5%] flex-col items-center justify-between bg-[#292A2F] p-3">
          <NavBar {baseCanvas} {initialData} />
        </div>
        {#if !$BadgeState.resumeModal}
          <div class="relative z-[5] flex h-full w-full">
            <BadgeSection bind:loadingText bind:showCropLoader bind:canvas={baseCanvas} bind:cropCanvas />
          </div>
        {/if}
        <div style="height:calc(100% - 40px);" class="relative flex h-full w-full flex-col gap-3 p-3 md:w-2/5">
          <TitleCard
            on:crop={() => {
              cropConfirm = true
            }}
            bind:loader
            bind:loadingText
            {baseCanvas}
          />
        </div>

        <div class="absolute bottom-0 z-[8] w-full">
          <!-- <div class="absolute bottom-8 w-full translate-y-1/2 px-12 py-2"> -->
          <Footer />
        </div>
      </div>
    </div>
  {:else}
    <div class="h-screen w-screen bg-gray-c00">
      <div class="flex h-full w-full select-none flex-col items-center justify-center p-5">
        <h1 class="text-center text-lg font-bold text-blue-500">The Minimum screen resolution should be 1024px</h1>
        <h1 class="text- pt-2 font-bold text-gray-g00">
          Your screen resolution is {window.innerWidth}px X {window.innerHeight}px
        </h1>
        <h1 class="pt-2 text-sm font-bold text-gray-g00">
          Redirecting in <strong class="text-red-500">{countdown}</strong>
          seconds
        </h1>
      </div>
    </div>
  {/if}
</div>

{#if loader || showCropLoader}
  <LoadingScreen msg={loadingText} />
{/if}

{#if $BadgeState.resumeModal}
  <ResumeStartmodal on:click={resumeProcess} on:startAgain={differentIdCondition} />
{/if}

{#if cropConfirm}
  <CropConfirmationModal
    on:click={() => {
      cropConfirm = false
    }}
    on:confirm={() => {
      cropConfirm = false
      cropCanvas = true
    }}
  />
{/if}
